import styled from 'styled-components'

export const ChooseReservationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`

export const Loading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 150px;
`